<div class="waiting-room-container">
  <div class="overlay-background">
    <div class="waiting-room-header">
      <div class="waiting-room-logo">
        <img src="assets/img/diseno/logo.png" />
      </div>
      <div class="waiting-room-support">
        <div class="content">
          <p class="text" [translate]="'HEADER.TECHNICAL_SUPPORT'"></p>
          <p class="number">{{supportPhone}}</p>
        </div>
        <div class="icon-desktop">
          <i class="icon-call_blue"></i>
        </div>
         <!-- BOTTON MOBILE SUPPORT MOBILE -->
        <div class="support-mobile-btn more-btn">			
          <div class="suppor-icon" (click)="showSupportNumber()">
            <i class="icon-call_blue"></i>
            <p class="text" [translate]="'HEADER.TECHNICAL_SUPPORT'"></p>
          </div>
          
          <!-- CONTAINER TELÉFONO SOPORTE TOOLTIP -->
          <div class="support-number-container box-content">
            <sas-support-tooltip></sas-support-tooltip>
          </div>
          <!-- @if(!hide){
              <div class="box-content" >
                <p class="text"  translate="HEADER.TECHNICAL_SUPPORT"></p>
                <a href="tel:+{{supportPhone}}" class="number">{{supportPhone}}</a>
              </div>
            } -->
        </div>
      </div>
    </div>

    <div class="overlay-container">
      <div class="overlay-container-left">
        <div>
          <h1 class="title" [translate]="'DISCONNECTED.GREETING'"></h1>
          <h1><span class="fw-normal" [translate]="'DISCONNECTED.NOT_FOUND.TITLE'"></span></h1>
        </div>
      </div>
      <!-- OVERLEY CONTAINER NORMAL -->
      <div class="overlay-container-right">
        <!-- CONFIGURACIÓN GENERAL -->
        <div class="overlay-info-container">
          <div class="all-settings"
            [ngStyle]="{'visibility': devicesTestActivate && audioQuestion ? 'hidden' : 'visible'}">

            <div class="overlay-info-container-video" style="background-color: black;"></div>

            <div class="overlay-info-setting">
              <div class="overlay-setting-item">
                <div class="overlay-setting-icon">
                  <i class="icon-camera"></i>
                </div>
                <div class="overlay-setting-txt" [translate]="'DISCONNECTED.TEST.CAMERA'"></div>
                <div class="toggle-container">
                  <label class="switch">
                    <input id="cameraTest" type="checkbox" [disabled]="true" [checked]="false">
                    <span class="slider round"></span>
                  </label>
                </div>
              </div>
              <div class="overlay-setting-item">
                <div class="overlay-setting-icon">
                  <i class="icon-mic"></i>
                </div>
                <div class="u-flex u-flex-column overlay-setting-txt">
                  <div [translate]="'DISCONNECTED.TEST.MIC'"></div>
                  <meter id="publisherMeter" min="0" max="1" value="0"></meter>
                </div>
                <div class="toggle-container">
                  <label class="switch">
                    <input type="checkbox" [disabled]="true" [checked]="false">
                    <span class="slider round"></span>
                  </label>
                </div>
              </div>
              <!-- AUDIO Y TEST CONECTIVIDAD AHORA NO APARCEN -->
              @if(devicesTestActivate){
                <div class="overlay-setting-item pointer" (click)="playAudio()">
                  <div class="overlay-setting-icon">
                    <i class="icon-speaker"></i>
                  </div>
                  <div class="overlay-setting-txt u-flex u-flex-column">
                    <div [translate]="'DISCONNECTED.TEST.ALTAVOZ'"></div>
                  </div>
                  <i class="icon-check" [ngClass]="{'nochecked' : !audioOutputTest }"></i>
                </div>
              }
              @if(devicesTestActivate){
                <div class="overlay-setting-item">
                  <div class="overlay-setting-icon">
                    <i class="icon-wifi"></i>
                  </div>
                  <div class="overlay-setting-txt u-flex u-flex-column">
                    <div [translate]="'DISCONNECTED.TEST.TEST'"></div>
                    <div class="meter-container wifi-test">
                      <div class="meter-level" [ngStyle]="{'width.%': levelWidth}"></div>
                    </div>
                  </div>
                  <i class="icon-check" [ngClass]="{'nochecked' : levelWidth !== 100 }"></i>
                </div>
              }
            </div>
          </div>

          @if(devicesTestActivate && audioQuestion){
            <!-- TEST DE AUDIO -->
            <div class="audio-settings">
              <i class="icon-display-audio"></i>
              <div class="u-divider-bottom-xl u-divider-top-xl" [translate]="'DISCONNECTED.AUDIO.TEXT1'"></div>
              <div class="u-divider-bottom-xl"
                [translate]="!audioStartTest ? 'DISCONNECTED.AUDIO.TEXT2' : 'DISCONNECTED.AUDIO.START_TEST'">
              </div>
              <div [ngClass]="!audioStartTest ? 'u-flex u-flex-justify-content-between' : ''"
                class="button-container u-divider-top-xxl u-divider-bottom-sm">
  
                @if(audioStartTest){
                  <button class="btn btn-primary btn-lg u-divider-top-xxl" type="submit"
                    (click)="playAudio()">
                    {{'DISCONNECTED.AUDIO.START' | translate}}
                  </button>
                }
                @if(!audioStartTest){
                  <button class="btn btn-primary outline btn-lg u-divider-top-xxl" type="submit"
                    (click)="audioTestKo()">
                    {{'DISCONNECTED.AUDIO.NO' | translate}}
                  </button>
                }
                @if(!audioStartTest){
                  <button class="btn btn-primary btn-lg u-divider-top-xxl" type="submit"
                    (click)="audioTestOk()">
                    {{'DISCONNECTED.AUDIO.YES' | translate}}
                  </button>
                }
              </div>
            </div>
          }
        </div>

        @if(devicesTestActivate){
          <!-- TEST CONTAINER DESKTOP -->
          <div class="overlay-info-container test-container" >
            @if(!showConnectivityTestResults){
              <div class="u-flex u-flex-justify-content-between u-divider-bottom-sm">
                <div class="u-flex u-flex-align-items-center test-container-item">
                  <div [translate]="'DISCONNECTED.TEST.VIDEO'">
                  </div>
                  <i [ngClass]="{'icon-check' : videoTest, 'icon-close': !videoTest}"></i>
                </div>
                <div class="u-flex u-flex-align-items-center test-container-item">
                  <div [translate]="'DISCONNECTED.TEST.AUDIO'"></div>
                  <i [ngClass]="{'icon-check' : audioTest, 'icon-close': !audioTest}"></i>
                </div>
                <div class="u-flex u-flex-align-items-center test-container-item">
                  <div [translate]="'DISCONNECTED.TEST.NET'"></div>
                  <i [ngClass]="{'icon-check' : networkTest, 'icon-close': !networkTest}"></i>
                </div>
              </div>
            }
  
            @if(!showConnectivityTestResults && networkTest && audioOutputTest){
              <div class="bold u-txt-center t-green" [translate]="'DISCONNECTED.TEST.MSG_OK'"></div>
            }
            @if(!showConnectivityTestResults && !networkTest && !audioOutputTest){
              <div class="bold u-txt-center t-red" [translate]="'DISCONNECTED.TEST.MSG_KO'"></div>
            }
            @if(showConnectivityTestResults){
              <div class="bold u-txt-center" [translate]="'DISCONNECTED.TEST.MSG_INFO'">
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>